// src/firebase.ts

import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  deleteToken,
  Messaging,
} from "firebase/messaging";
import { getAnalytics, Analytics } from "firebase/analytics";
import { useWebPushStore } from "@/modules/web-push/store";

const firebaseConfig = {
  apiKey: "AIzaSyAu7AvYqihkgvp1r9RQ-ovjQa_NeOotchs",
  authDomain: "rdo-community-project.firebaseapp.com",
  projectId: "rdo-community-project",
  storageBucket: "rdo-community-project.appspot.com",
  messagingSenderId: "10639заб46263746",
  appId: "1:1063946263746:web:a76302943073c8555f6f5b",
  measurementId: "G-TRLBJ2JMJP",
};

const app = initializeApp(firebaseConfig);

const messaging: Messaging = getMessaging(app);

let analytics: Analytics | null = null;
if (typeof window !== "undefined") {
  analytics = getAnalytics(app);
}

export function logEvent(label: string) {
  if (analytics) {
    if (typeof window.gtag === "function") {
      window.gtag("event", `${label}`, {
        content_type: "user_action",
        item_id: label,
      });
    }
  }
}

export async function requestFirebaseToken(user: any): Promise<string | null> {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission not granted");
      return null;
    }

    const registration = await navigator.serviceWorker.register("/sw.js");

    await registration.update();

    if (registration.waiting) {
      registration.waiting.postMessage({ type: "SKIP_WAITING" });
    }

    await waitUntilActive(registration);

    const token = await getToken(messaging, {
      vapidKey:
        "BCCfLuopbA8Pl3gU9z4XkxQ9Xs3X8dWlpX8D874L9cBAef4qZFrdLysfaNvXKY4ER8f4hSjeDQYKLJBGG2UXmsE",
      serviceWorkerRegistration: registration,
    });

    const store = useWebPushStore();

    const fcmTokenInDevices = user?.devices?.find(
      (item: any) => item.fcm_token === token
    );

    if (!fcmTokenInDevices) {
      await store.getEnablePush(token);
    }
    return token || null;
  } catch (err) {
    console.error("Failed to get FCM token:", err);
    return null;
  }
}

export async function disableFirebasePush(): Promise<void> {
  logEvent("disableFirebasePush");
  try {
    await deleteToken(messaging);
  } catch (err) {
    console.error("Error disabling push notifications:", err);
  }
}

async function waitUntilActive(reg: ServiceWorkerRegistration): Promise<void> {
  if (reg.active) {
    return;
  }

  await new Promise<void>((resolve) => {
    const check = setInterval(() => {
      if (reg.active) {
        clearInterval(check);
        resolve();
      }
    }, 100);
  });
}

export { messaging };
